// extracted by mini-css-extract-plugin
export default {"panel":"Panel_panel__UQ4Fy","info":"Panel_info__yRqb0","btns":"Panel_btns__U1Kqg","button":"Panel_button__vhz+k"};